import { ReactNode, FC, createContext, useState, useMemo } from 'react';

const ProductContext = createContext<any>({});

type ProductProps = {
  children: ReactNode;
};

const Product: FC<ProductProps> = ({ children }) => {
  const [productSettings, setProductSettings] = useState({});

  const ProductProviderValue = useMemo(
    () => ({ productSettings, setProductSettings }),
    [productSettings, setProductSettings],
  );

  return (
    <ProductContext.Provider value={ProductProviderValue}>
      {children}
    </ProductContext.Provider>
  );
};

export { Product, ProductContext };
